import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function ArrowIcon(props) {
  return (
    <SvgIcon fill="none" viewBox="0 0 36 12" {...props}>
      <path
        d="M2 10L18.4051 3L34 10"
        stroke="#D9D9D9"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}

export default ArrowIcon;
